import React from "react";

export default function QuantityControl({
  label,
  value,
  onChange,
  min = 1,
  max = 4,
}) {
  const handleDecrease = () => {
    if (value > min) onChange(value - 1);
  };

  const handleIncrease = () => {
    if (value < max) onChange(value + 1);
  };

  const handleInputChange = (e) => {
    let val = parseInt(e.target.value);
    if (isNaN(val)) val = min;
    if (val < min) val = min;
    if (val > max) val = max;
    onChange(val);
  };

  return (
    <div className="input_box quantity_box">
      <label>{label}</label>
      <div className="quantity">
        <button
          className="minus"
          aria-label="Decrease"
          onClick={handleDecrease}
          disabled={value <= min}
          type="button"
        >
          -
        </button>
        <input
          type="number"
          className="input-box"
          value={value}
          min={min}
          max={max}
          onChange={handleInputChange}
        />
        <button
          className="plus"
          aria-label="Increase"
          onClick={handleIncrease}
          disabled={value >= max}
          type="button"
        >
          +
        </button>
      </div>
    </div>
  );
}
